import { render, staticRenderFns } from "./updateWebSocialProofContent.vue?vue&type=template&id=2413c708&"
import script from "./updateWebSocialProofContent.vue?vue&type=script&lang=js&"
export * from "./updateWebSocialProofContent.vue?vue&type=script&lang=js&"
import style0 from "./updateCampaignContent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports